export const root = typeof window === 'undefined' ? global : window;
export default root;



// WEBPACK FOOTER //
// ./assets/js/global/windowCheck.es.js